// Личные дела из других календарей Google (серые блоки в расписании): грузятся отдельно от состояния кабинета,
// по мере листания — на две недели назад и полтора месяца вперёд от нужного дня.
import { addDays } from '@praktika/core';
import { rpc } from './api.ts';
import { esc } from './dom.ts';
import { current, render } from './nav.ts';
import { S } from './state.ts';

export interface BusyItem { date: string; start: number; end: number; title: string; cal?: string; allDay?: boolean;
  unk?: boolean }          // встреча календаря сессий, которую приложение не узнало, — ждёт разбора

const loaded: { from: string; to: string; items: Record<string, BusyItem[]> } = { from: '', to: '', items: {} };
let loading = false;

export function busyOf(date: string): BusyItem[] { return loaded.items[date] ?? []; }
export function busyTimed(date: string): BusyItem[] { return busyOf(date).filter((b) => !b.allDay && b.end > b.start); }
export function busyAllDay(date: string): BusyItem[] { return busyOf(date).filter((b) => b.allDay); }

// Календари «личных дел» поменяли — перечитать.
export function resetBusy(): void { Object.assign(loaded, { from: '', to: '', items: {} }); }

export function ensureBusy(date: string): void {
  if (!S?.calendar?.busyCals?.length || loading || (loaded.from && loaded.from <= date && date <= loaded.to)) return;
  let from = addDays(date, -14), to = addDays(date, 45);
  if (loaded.from) { if (loaded.from < from) from = loaded.from; if (loaded.to > to) to = loaded.to; }
  loading = true;
  rpc<{ from: string; to: string; items: BusyItem[] }>('busy', from, to).then((r) => {
    const items: Record<string, BusyItem[]> = {};
    for (const x of r.items) (items[x.date] ??= []).push(x);
    Object.assign(loaded, { from: r.from, to: r.to, items });
    loading = false;
    if (/^(today|sched|book|move)$/.test(current().name)) render();
  }, () => {
    // календарь не ответил — этот промежуток пока без личных дел, без повторов на каждой отрисовке
    loading = false;
    Object.assign(loaded, { from, to, items: {} });
  });
}

export function busyDayNote(date: string): string {
  const ad = busyAllDay(date);
  return ad.length ? ' · <b>занят: ' + esc(ad.map((b) => b.title).join(', ')) + '</b>' : '';
}
